import { useMemo } from "react"
import { useQuery } from "urql"

import "../graphql/salesQuoteEmailQueries"

import { GetSalesQuoteEmailPreviewDocument } from "@/graphql/codegen/graphql"

export interface SalesQuoteEmailPreviewAttachment {
  filename: string
  signedUrl: string
}

export interface SalesQuoteEmailPreviewData {
  subject: string
  bodyHtml: string
  submittedOn: string
  canSend: boolean
  attachments: SalesQuoteEmailPreviewAttachment[]
}

interface UseGetSalesQuoteEmailPreviewReturn {
  preview?: SalesQuoteEmailPreviewData
  isFetching: boolean
  error?: string
}

export const useGetSalesQuoteEmailPreview = (
  quoteGroupId: number,
  emailNote?: string
): UseGetSalesQuoteEmailPreviewReturn => {
  const [{ data, fetching, error }] = useQuery({
    query: GetSalesQuoteEmailPreviewDocument,
    variables: { quoteGroupId, emailNote: emailNote?.trim() || null },
  })

  const output = data?.salesPipeline.salesQuoteEmailPreview

  const preview = useMemo<SalesQuoteEmailPreviewData | undefined>(() => {
    if (output?.__typename !== "SalesQuoteEmailPreviewSuccess") return undefined
    const { subject, bodyHtml, submittedOn, canSend, attachments } = output.preview
    return { subject, bodyHtml, submittedOn, canSend, attachments: [...attachments] }
  }, [output])

  const errorMessage =
    error?.message ?? (output?.__typename === "SalesQuoteEmailPreviewFailure" ? output.error.message : undefined)

  return { preview, isFetching: fetching, error: errorMessage }
}
